import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '@wtag/rcl-icon';

const MenuLabel = ({ onClick, label, isError, icon, isVisible, canExchange }) => (
  <div
    className={classNames('search-menu__menu-label', {
      'search-menu__label--error': isError,
      'search-menu__menu-label--active': isVisible,
      'search-menu__menu-label--exchange': canExchange,
    })}
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyPress={onClick}
  >
    {icon}
    <span data-cy="travelapp-car-search-label">{label}</span>
    <Icon
      name={isVisible ? 'iconUpChevron' : 'iconDownChevron'}
      color={isVisible ? 'tertiary' : 'default'}
      size="tiny"
    />

  </div>
);

MenuLabel.defaultProps = {
  isError: false,
  icon: null,
  isVisible: false,
  canExchange: false,
};

MenuLabel.propTypes = {
  isError: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.element,
  isVisible: PropTypes.bool,
  canExchange: PropTypes.bool,
};

export default MenuLabel;
